import { SmallText, colors } from 'app-v2/design-systems'
import { BORDER, SPACING } from 'app-v2/design-tokens'
import { Text } from 'app/common/typography'
import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

type AccountInformationRowProps = {
    labelKey?: string,
    value?: string
}

const AccountInformationRow = ({
    labelKey,
    value
}: AccountInformationRowProps) => {
    const intl = useIntl()
    return (
        <StyledAccountInformationRow>
            <StyledLabelContainer>
                <SmallText>{intl.formatMessage({ id: labelKey })}</SmallText>
            </StyledLabelContainer>

            <StyledValueContainer>
                <Text>{value}</Text>
            </StyledValueContainer>
        </StyledAccountInformationRow>
    )
}

const StyledAccountInformationRow = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    min-height: ${SPACING.XXL};
    gap: ${SPACING.S};
    align-items: center;
`

const StyledLabelContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    text-align: end;
    width: 30%;
`

const StyledValueContainer = styled.div`
    width: 70%;
`

export const AccountInformation = () => {
    const intl = useIntl()
    const { lastname, firstname, phone, email, birthdate } = useSelector(
        state => state.kingdomProfilePageState
    )
    const { kingdomAuthCode, pointInfos } = useSelector(
        state => state.kingdomDashboardPageState
    )
    return (
        <StyledAccountContainer>
            <AccountInformationRow
                labelKey="kingdom.profile.form.delete.account.lastname"
                value={lastname}
            />

            <AccountInformationRow
                labelKey="kingdom.profile.form.delete.account.firstname"
                value={firstname}
            />

            <AccountInformationRow
                labelKey="kingdom.profile.form.delete.account.phone"
                value={phone}
            />

            <AccountInformationRow
                labelKey="kingdom.profile.form.delete.account.email"
                value={email}
            />

            <AccountInformationRow
                labelKey="kingdom.profile.form.delete.account.birthdate"
                value={birthdate}
            />

            <AccountInformationRow
                labelKey="kingdom.profile.form.delete.account.kingdomId"
                value={kingdomAuthCode}
            />

            <AccountInformationRow
                labelKey="kingdom.profile.form.delete.account.crownNumber.label"
                value={intl.formatMessage(
                    { id: 'kingdom.profile.form.delete.account.crownNumber' },
                    { crownNumber: pointInfos?.points }
                )}
            />
        </StyledAccountContainer>
    )
}

const StyledAccountContainer = styled.div`
    background-color: ${colors.meltyYellow}14;
    display: flex;
    flex-direction: column;
    border-radius: ${BORDER.RADIUS.L};
    width: 100%;
    padding: ${SPACING.XS};
    box-sizing: border-box;
    gap: ${SPACING.XXS};
`
